"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrDesktopNavMenuSkeleton = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const SkeletonWrapper = styled_components_1.default.div({
    display: 'flex',
    width: '100%',
});
const FdrDesktopNavMenuSkeleton = () => {
    const [width, setWidth] = (0, react_1.useState)(200);
    const skeletonRef = (0, react_1.useRef)(null);
    function updateWidth() {
        if (skeletonRef.current) {
            setWidth(skeletonRef.current.offsetWidth);
        }
    }
    (0, libs_hooks_dom_1.useWindowResize)(updateWidth);
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(updateWidth, []);
    const L = 100;
    const P = 30;
    return (react_1.default.createElement(SkeletonWrapper, { ref: skeletonRef },
        react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { height: 72, width: width, uid: "navMenuSkeleton", style: { height: '72px', width: `100%` } }, Array.from({ length: Math.ceil(width / (L + P)) - 1 }).map((_, i) => (react_1.default.createElement("rect", { key: i, x: width - (L + P) * i - L, y: 30, rx: "5", ry: "5", width: L, height: 13 }))))));
};
exports.FdrDesktopNavMenuSkeleton = FdrDesktopNavMenuSkeleton;
//# sourceMappingURL=fdr-desktop-nav-menu.skeleton.js.map